import { render, staticRenderFns } from "./company.vue?vue&type=template&id=974a58ea&"
import script from "./company.js?vue&type=script&lang=js&"
export * from "./company.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports